// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Grid,
//   TextField,
//   Button,
//   CircularProgress,
//   Alert,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Checkbox,
//   FormGroup,
//   FormControlLabel,
// } from '@mui/material';
// import axios from 'axios';

// const APIURL = process.env.REACT_APP_BASE_API_URL;
// const API_URL = `${APIURL}/api/module-permissions`; // ✅ Update with your actual POST endpoint

// interface AddModulePermissionsProps {
//   handleClose: () => void;
//   onSubmit?: () => void;
//   fetchPermissionsData?: () => void;
// }

// const AddModulePermissions: React.FC<AddModulePermissionsProps> = ({
//   handleClose,
//   onSubmit,
//   fetchPermissionsData,
// }) => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');

//   // Dropdown data
//   const [vendors, setVendors] = useState<any[]>([]);
//   const [modules, setModules] = useState<any[]>([]);

//   // Form data
//   const [formData, setFormData] = useState({
//     vendorId: '',
//     moduleId: '',
//     permissions: [] as string[],
//   });

//   // Sample permissions list (replace with backend list if needed)
//   const permissionsList = [
//     'Create',
//     'Read',
//     'Update',
//     'Delete',
//     'Approve',
//     'Reject',
//   ];

//   // ✅ Fetch dropdown data from backend
//   useEffect(() => {
//     const fetchDropdowns = async () => {
//       try {
//         // Replace with your actual APIs once available
//         const vendorRes = await axios.get(`${APIURL}/api/vendors`);
//         const moduleRes = await axios.get(`${APIURL}/api/modules/showAll`);
//         setVendors(vendorRes.data || []);
//         setModules(moduleRes.data || []);
//       } catch (err) {
//         console.error('Error fetching dropdown data:', err);
//       }
//     };
//     fetchDropdowns();
//   }, []);

//   // ✅ Handle field changes
//   const handleChange = (e: any) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // ✅ Handle permission checkbox changes
//   const handlePermissionChange = (permission: string) => {
//     setFormData(prev => {
//       const exists = prev.permissions.includes(permission);
//       const updatedPermissions = exists
//         ? prev.permissions.filter(p => p !== permission)
//         : [...prev.permissions, permission];
//       return { ...prev, permissions: updatedPermissions };
//     });
//   };

//   // ✅ Submit handler
//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');
//     setSuccess('');

//     try {
//       const payload = {
//         vendorId: formData.vendorId,
//         moduleId: formData.moduleId,
//         permissions: formData.permissions,
//       };

//       const response = await axios.post(API_URL, payload);

//       if (response.data) {
//         setSuccess('Module permissions assigned successfully!');
//         setFormData({ vendorId: '', moduleId: '', permissions: [] });
//         if (onSubmit) onSubmit();
//         if (fetchPermissionsData) fetchPermissionsData();
//         handleClose();
//       }
//     } catch (err: any) {
//       console.error('Error creating module permissions:', err);
//       const errorMessage = err.response?.data?.message || 'Failed to save permissions';
//       setError(errorMessage);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ✅ Cancel handler
//   const handleCancel = () => {
//     setFormData({ vendorId: '', moduleId: '', permissions: [] });
//     setError('');
//     setSuccess('');
//     handleClose();
//   };

//   return (
//     <Box sx={{ maxWidth: 600, mx: 'auto', p: 3 }}>
//       <Typography variant="h5" gutterBottom>
//         Add Module Permissions
//       </Typography>

//       <form onSubmit={handleSubmit}>
//         {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
//         {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

//         <Grid container spacing={2}>
//           {/* Vendor Dropdown */}
//           <Grid item xs={12}>
//             <FormControl fullWidth required>
//               <InputLabel id="vendor-label">Vendor</InputLabel>
//               <Select
//                 labelId="vendor-label"
//                 name="vendorId"
//                 value={formData.vendorId}
//                 label="Vendor"
//                 onChange={handleChange}
//               >
//                 {vendors.map(vendor => (
//                   <MenuItem key={vendor.id} value={vendor.id}>
//                     {vendor.name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>

//           {/* Application Module Dropdown */}
//           <Grid item xs={12}>
//             <FormControl fullWidth required>
//               <InputLabel id="module-label">Application Module</InputLabel>
//               <Select
//                 labelId="module-label"
//                 name="moduleId"
//                 value={formData.moduleId}
//                 label="Application Module"
//                 onChange={handleChange}
//               >
//                 {modules.map(module => (
//                   <MenuItem key={module.id} value={module.id}>
//                     {module.name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>

//           {/* Permissions Checkboxes */}
//           <Grid item xs={12}>
//             <Typography variant="subtitle1" gutterBottom>
//               Select Permissions
//             </Typography>
//             <FormGroup>
//               {permissionsList.map(permission => (
//                 <FormControlLabel
//                   key={permission}
//                   control={
//                     <Checkbox
//                       checked={formData.permissions.includes(permission)}
//                       onChange={() => handlePermissionChange(permission)}
//                     />
//                   }
//                   label={permission}
//                 />
//               ))}
//             </FormGroup>
//           </Grid>

//           {/* Buttons */}
//           <Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
//             <Button onClick={handleCancel} disabled={loading} sx={{ mr: 2 }}>
//               Cancel
//             </Button>
//             <Button type="submit" variant="contained" color="primary" disabled={loading}>
//               {loading ? <CircularProgress size={24} /> : 'Save Permissions'}
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
//     </Box>
//   );
// };

// export default AddModulePermissions;

import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Grid, Button, CircularProgress, Alert,
  FormControl, InputLabel, Select, MenuItem, Checkbox,
  FormControlLabel,
  Snackbar
} from '@mui/material';
// import axios from 'axios';
import { get,post } from 'src/services/httpClient.service';
import { authenticationService } from 'src/services/authentication.service';

const API_URL = process.env.REACT_APP_BASE_API_URL;


interface AddModulePermissionsProps {
  handleClose: () => void;
  onSubmit?: () => void;
  fetchPermissionsData?: () => void;
}

const AddModulePermissions: React.FC<AddModulePermissionsProps> = ({
  handleClose,
  onSubmit,
  fetchPermissionsData
}) => {
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info' as 'error' | 'success' | 'info' | 'warning'
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Dropdown data
  const [vendorsList, setVendors] = useState([]);
  const [modules, setModules] = useState<any[]>([]);
  const [permissionsList, setPermissionsList] = useState<any[]>([]);

  const {vendorId, franchiseId} = authenticationService.getVendorFranchiseIds();

  // Form data
  const [formData, setFormData] = useState({
    vendorId: '',
    moduleId: '',
    permissions: [] as string[],
    permissionIdsList: [] as string[]
  });

  // 🔹 Fetch Vendors (handles XML or JSON)
  const fetchVendors = async () => {
    try {
      const response = await get(`${API_URL}/api/vendors`);

      setVendors(response);
    } catch (err) {
      console.error('Error fetching vendors:', err);
      setError('Failed to load vendors.');
    }
  };

  // 🔹 Fetch Modules
    const fetchModules = async () => {
        try {
            const response = await get(`${API_URL}/api/applicationModules/vendor/${vendorId}/findAll`);

            // If response.data is not an array, extract the right part
            const data = Array.isArray(response.data)
                ? response.data
                : response.data?.data || [];

            setModules(data);
        } catch (err) {
            console.error('Error fetching modules:', err);
            setError('Failed to load application modules.');
        }
    };

  // 🔹 Fetch Permissions
  const fetchPermissions = async () => {
    try {
      const res = await get(`${API_URL}/api/permissions/findAll`);
      const data = Array.isArray(res.data?.data)
        ? res.data.data
        : Array.isArray(res.data)
        ? res.data
        : [];

      setPermissionsList(data);

      // Pre-select all permissions
      if (data.length > 0) {
        setFormData((prev) => ({
          ...prev,
          permissions: data.map((p) => p.id),
        }));
      }
    } catch (err) {
      console.error('Error fetching permissions:', err);
      setError('Failed to load permissions.');
    }
  };

  // Re-select Franchisees after franchiseList loads
  useEffect(() => {
    if (permissionsList.length > 0 && formData.permissionIdsList.length > 0) {
      setFormData(prev => ({
        ...prev,
        permissionIdsList: [...prev.permissionIdsList]
      }));
    }
  }, [permissionsList]);

  // 🔹 Fetch all dropdowns on mount
  useEffect(() => {
    fetchVendors();
    fetchModules();
    fetchPermissions();
  }, []);

  // 🔹 Handle form field change
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

   const showSnackbar = (message: string, severity: 'error' | 'success' | 'info' | 'warning') => {
    setSnackbar({ open: true, message, severity });
  };

   const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // 🔹 Handle form submit
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
   if (!formData.vendorId) {
      showSnackbar('Please select a vendor.', 'warning');
      return;
    }
    if (!formData.moduleId) {
      showSnackbar('Please select an application module.', 'warning');
      return;
    }
    if (formData.permissionIdsList.length === 0) {
      showSnackbar('Please select at least one permission.', 'warning');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const payload = {
        vendorId: formData.vendorId,
        appModule: {
          id: formData.moduleId
        },
        applicationModuleId: formData.moduleId,
        permissionIdsList: formData.permissionIdsList,
      };
      
      const response = await post(`${API_URL}/api/modulepermission`, payload);

      if (response.data) {
        showSnackbar('Module permissions assigned successfully!', 'success');
        setFormData({ vendorId: '', moduleId: '', permissions: [], permissionIdsList: [] });
        if (onSubmit) onSubmit();
        if (fetchPermissionsData) fetchPermissionsData();
        handleClose();
      }
    } catch (err: any) {
      console.error('Error creating module permissions:', err);
      const errorMessage =
        err.response?.data?.message || 'Failed to save module permissions.';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Handle cancel
  const handleCancel = () => {
    setFormData({ vendorId: '', moduleId: '', permissions: [], permissionIdsList: [] });
    setError('');
    setSuccess('');
    handleClose();
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', p: 3 }}>
      {/* {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      {success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {success}
        </Alert>
      )} */}

      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          {/* 🔸 Vendor Dropdown */}
          <Grid item xs={12}>
            <FormControl fullWidth required>
              <InputLabel id="vendor-label">Vendor</InputLabel>
              <Select
                labelId="vendor-label"
                name="vendorId"
                value={formData.vendorId}
                label="Vendor"
                onChange={handleChange}
              >
                {vendorsList.map((vendor) => (
                  <MenuItem key={vendor.vendorId} value={vendor.vendorId}>
                    {vendor.vendorName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* 🔸 Application Module Dropdown */}
          <Grid item xs={12}>
            <FormControl fullWidth required>
              <InputLabel id="module-label">Application Module</InputLabel>
              <Select
                labelId="module-label"
                name="moduleId"
                value={formData.moduleId}
                label="Application Module"
                onChange={handleChange}
              >
               {Array.isArray(modules) && modules.length > 0 ? (
                modules.map((module: any) => (
                 <MenuItem key={module.id} value={module.id}>
                   {module.name}
                 </MenuItem>
                 ))
                 ) : (
                 <MenuItem disabled>No modules available</MenuItem>
              )}
              </Select>
            </FormControl>
          </Grid>

          {/* 🔸 Permissions Checkboxes */}
          <Grid item xs={12}>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              Permissions List
            </Typography>

            <Box
              sx={{
                border: '1px solid #444',
                borderRadius: '6px',
                padding: '12px',
                maxHeight: '160px',
                overflowY: 'auto',
                display: 'flex',
                flexWrap: 'wrap',
                gap: '12px',
              }}
            >
              {permissionsList.map((permission) => (
                <FormControlLabel
                  key={permission.id}
                  control={
                    <Checkbox
                      checked={formData.permissionIdsList.includes(permission.id)}
                      onChange={(e) => {
                        const { checked } = e.target;

                        if (permission.name.toLowerCase() === "all") {
                          // 🔸 If "All" is toggled — select or deselect all
                          setFormData((prev) => ({
                            ...prev,
                            permissionIdsList: checked
                              ? permissionsList.map((p) => p.id)
                              : [],
                          }));
                        } else {
                          // 🔸 Toggle individual permission
                          setFormData((prev) => {
                            const updated = checked
                              ? [...prev.permissionIdsList, permission.id]
                              : prev.permissionIdsList.filter((id) => id !== permission.id);

                            // Find the "All" permission
                            const allPerm = permissionsList.find(
                              (p) => p.name.toLowerCase() === "all"
                            );

                            // Check if all (except "All") are selected
                            const nonAllIds = permissionsList
                              .filter((p) => p.name.toLowerCase() !== "all")
                              .map((p) => p.id);

                            const allSelected = nonAllIds.every((id) =>
                              updated.includes(id)
                            );

                            // 🔸 Sync "All" checkbox
                            if (allPerm) {
                              if (allSelected && !updated.includes(allPerm.id)) {
                                updated.push(allPerm.id);
                              } else if (!allSelected && updated.includes(allPerm.id)) {
                                updated.splice(updated.indexOf(allPerm.id), 1);
                              }
                            }

                            return { ...prev, permissionIdsList: updated };
                          });
                        }
                      }}
                    />
                  }
                  label={permission.name}
                />
              ))}
            </Box>
          </Grid>



          {/* 🔸 Buttons */}
          <Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={handleCancel} disabled={loading} sx={{ mr: 2 }}>
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : 'Save Permissions'}
            </Button>
          </Grid>
        </Grid>
      </form>

       {/* 🔹 Snackbar for messages */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default AddModulePermissions;
